export const DISTRIBUTION_OPTIONS = [
  'amasian',
  'amasian-staging',
  'odk',
  'odk-staging',
  'odc',
  'odc-staging',
];
export const CLOUDFRONT_DOMAIN =
  process.env.REACT_APP_CLOUDFRONT_DOMAIN || 'https://d1rz8umx2a4nuw.cloudfront.net';
